//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  
  export class ContactModel extends ModelBase {
      static readonly $typeName = 'ContactModel';
      public email: string;
      public key: string;
      public name: string;
      public number: string;
      
  }



// WEBPACK FOOTER //
// ./src/app/submission/models/ContactModel.ts